/**
 * Login — pantalla de autenticación (dirección visual «Gabinete», #280).
 *
 * R-PT-05: Pórtico hace el login y pasa la identidad a R0.
 *          No decide roles ni permisos — eso lo resuelve el Kernel.
 *
 * Modo real: el botón salta al hosted UI de Cognito (Authorization Code +
 * PKCE, src/auth/cognito.js); la SPA nunca ve la contraseña. El primer
 * acceso pide cambiar la contraseña temporal (#243).
 * Modo mock: entra directo contra el descriptor local.
 *
 * Nota de arquitectura: el tenant (y su `logo_url`) se resuelve en el
 * bootstrap, DESPUÉS de este paso — antes de entrar no hay tenant conocido
 * (US-58). Si algún día el login precede con datos públicos de marca, este
 * componente ya está listo para consumir `tenant.branding.logo_url`; hasta
 * entonces usa la insignia neutra de plataforma.
 */

import { useSession } from '../context/SessionContext.jsx'
import { isMock } from '../api/client.js'
import { AgentAvatar } from './AgentAvatar.jsx'

export default function Login() {
  const { login, loading, error, tenant, user } = useSession()
  const logoUrl = tenant?.branding?.logo_url

  return (
    <div className="login-root">
      <div className="login-card">
        {logoUrl ? (
          <img className="login-logo" src={logoUrl} alt="DKtec" />
        ) : (
          <div className="login-logo--fallback" aria-hidden="true">P</div>
        )}

        <h1 className="login-title">Pórtico</h1>
        <p className="login-subtitle">La ventana al gemelo · dkagora.ai</p>

        <div className="login-identity">
          <span className="login-identity__label">Identidad delegada · R0</span>
          <div className="login-identity__row">
            <AgentAvatar name={user?.display_name ?? 'R0'} size={26} />
            <span className="login-identity__email">
              {user?.display_name ?? (isMock ? 'Modo mock' : 'Cognito · DKtec')}
            </span>
          </div>
        </div>

        {error && (
          <p className="login-error" role="alert">
            {error}
          </p>
        )}

        <button
          className="login-btn"
          type="button"
          onClick={login}
          disabled={loading}
        >
          {loading ? 'Entrando…' : 'Entrar al gabinete'}
        </button>

        <p className="login-footer">
          {isMock
            ? 'Modo mock · la identidad se delega a R0. El Pórtico no decide roles.'
            : (
              <>
                La identidad se verifica en Cognito y la resuelve el kernel (R-PT-05).{' '}
                ¿Problemas para acceder?{' '}
                <a href="mailto:soporte@dktec.es" className="login-link">
                  Contacta con DKtec
                </a>
              </>
            )}
        </p>
      </div>
    </div>
  )
}
